// src/components/Portfolio/DeficienciesObjects/GreenTeaExtract.js

const Neuroix = {
  productCode: "SBOVZ-NEU-12",
  productName: "Neuroix-12",
  ingredients: "Bacopa monnieri, Centella asiatica, Shiitake Vitamer Complex (B12-Corrinoids)",
  overview:"Botanical and whole food Vitamin Supplement for Nerve Health",
  assay:"L-Tryptophan: 100 mg; Vitamin B1: 0.7 mg: Vitamin B9: 110 mcg; B12-Corrinoids: 1.1 mcg; Selenium: 20 mcg; Zinc: 2 mg; Chromium: 25 mcg; Bacopa extract: 100 gm; Centella asiatica extract: 112 gm; Shiitake Vitamer Complex (B12-Corrinoids): 5 mg;",
  coNutrients:"Neuroix-12 formula has other nerve health promoting vitamins, minerals and herbal actives that functions in a holistic way to promote nerve health. Secondary metabolites include saponins, phytosterols, alkaloids, sterol glycosides, phenylethanoid glycosides, cucurbitacins and Pentacyclic triterpenoids (C30)",
  studies:"",
  benefits:"Neuroix-12 has natural mixed cobalamins (B12), coenzyme forms that are highly bio-available, when taken in supplement form, the body directly gets it into the mitochondria for the three M’s – mitochondria, myelin, and methylation. Individuals dealing with fibromyalgia-like pain or neuropathy, neurodegenerative, cardiac, joint or any identified mitochondria problems benefit from our natural mixed cobalamins. ",
  functionalUse: {
    main: "💊︎ Capsule",
    note: "(Note:- heat and light sensitive, prone to oxidative stress)"
  },
  bannerImage: [
    
    "images/Portfolio/OrgavitazForConditions/Neuroix-12.png"
    

  ],
  certificates: [
    "images/Portfolio/OrgavitazForDeficiencies/B12-Corrinoids/B12-L1.png",
    "images/Portfolio/OrgavitazForDeficiencies/B12-Corrinoids/B12-L2.png",
    "images/Portfolio/OrgavitazForDeficiencies/B12-Corrinoids/B12-L3.png",
    "images/Portfolio/OrgavitazForDeficiencies/B12-Corrinoids/B12-L4.png",
    "images/Portfolio/OrgavitazForDeficiencies/B12-Corrinoids/B12-L6.png",
   
  ]
};

export default Neuroix;
